/** @readonly Dashboard routes */
export const DASHBOARD_ROUTES = Object.freeze({
  HUB: '/r/dashboards',
  PARENT: '/r/dashboard/parent',
  TEACHER: '/r/dashboard/teacher',
  OPS: '/r/dashboard/opsdashboard',
});
